import { render, staticRenderFns } from "./DeviationReport.vue?vue&type=template&id=07cdbd82&scoped=true"
import script from "./DeviationReport.vue?vue&type=script&lang=js"
export * from "./DeviationReport.vue?vue&type=script&lang=js"
import style0 from "./DeviationReport.vue?vue&type=style&index=0&id=07cdbd82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cdbd82",
  null
  
)

export default component.exports